<template>
  <img :src="getUserLogo()" :width="logoWidth" :height="logoHeight || logoWidth"  alt="" :onerror="defaultImg">
</template>

<script>
  import {ApiService} from '/@/libs'
  import defaultImgIcon from '../../assets/images/nousericon.png'

  export default {
    name: 'user-icon',
    props: {
      logoPath: {
        required: true
      },
      logoWidth: {
        default: 0,
        type: Number,
      },
      logoHeight: {
        default: 0,
        type: Number,
      }
    },
    data() {
      return {
        defaultImg: `this.src="${defaultImgIcon}"`
      }
    },
    methods: {
      getUserLogo() {
        if (!this.logoPath) {
          return `${defaultImgIcon}`
        }
        if (this.logoPath.indexOf('base64') !== -1) {//如果是base64 直接返回
          return this.logoPath;
        }
        return `${ApiService.ImgHost}/${this.logoPath}_${this.logoWidth}x${this.logoHeight}.jpg`;
        // return `${ApiService.Pic}/dXNlci9sb2dv_${this.userId}_${this.logoWidth}x${this.logoHeight}.jpg?`
      }
    }
  }
</script>
<style scoped="scoped">
  img {
    border-radius: 50%;
    width: 100%;
    max-width: 100%;
    background-color: #FFFFFF;
  }
</style>
